<template>
    <div v-if="config.display" :style="{'width': config.width || '100%'}" class="control e-control">
        <div v-if="asField">
            <display-value :id="config.id" :value="value"></display-value>
        </div>
        <div v-else>
            <ejs-toast :ref="config.ref || config.id" v-bind="syncfusionConfig" :content="config.value"><div></div></ejs-toast>
            <p v-if="config.message && !config.hideMessage" class="input-info" v-html="ddStoreFilter(config.message)"></p>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { controlMixins } from "./controlMixins.js";

const toastComponent = {
    data: function () {
        return {};
    },
    mixins: [controlMixins],
    updated() {
        let ref = this.config.ref || this.config.id;
        if (this.value && this.$refs && this.$refs[ref] && !this.isShown) {
            this.isShown = true;
            this.$refs[ref].show();
        }
    },
    components: {
        'ejs-toast': defineAsyncComponent(() => import('@common/syncfusion/toast'))
    }
};

export { toastComponent };
export default toastComponent;
</script>
